import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    subjects: []
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'CONTACT_REQUEST': ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            commit('CONTACT_REQUEST');
            let url = 'users/profile';
            api({url: url, method: 'GET'})
                .then(resp => {
                    let profile = resp.data.data
                    commit('UPDATE_PROFILE', profile);
                    resolve(resp)
                })
                .catch(err => {
                    commit('CONTACT_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'CONTACT_SUBJECTS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('CONTACT_REQUEST');
            let url = 'contacts/get/subjects';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('CONTACT_REQUEST_SUCCESS');
                    commit('UPDATE_CONTACT_SUBJECTS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('CONTACT_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'CONTACT_FORM_REQUEST': ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            commit('CONTACT_REQUEST');
            let url = 'contacts/form/send';
            api({url: url, data: data, method: 'POST'})
                .then(resp => {
                    commit('CONTACT_REQUEST_SUCCESS');
                    resolve(resp)
                })
                .catch(err => {
                    commit('CONTACT_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
};

// ----------------------------- o

const mutations = {
    'CONTACT_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'CONTACT_REQUEST_SUCCESS': (state) => {
        state.errors = {};
        state.loading = false;
    },
    'UPDATE_CONTACT_SUBJECTS': (state, resp) => {
        state.subjects = resp;
    },
    'CONTACT_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
